// extracted by mini-css-extract-plugin
module.exports = {"PartnerGameSettings":"PartnerGameSettings_PartnerGameSettings__2bLWq","CurrencySelector":"PartnerGameSettings_CurrencySelector__11Hmc"};